import React from "react";
import PdfOutlinePanel from "@/component/common/previewer/feat/outline/PdfOutlinePanel";

const ProjectOutlinePanel: React.FC = () => {
  return <PdfOutlinePanel variant="sidebar" />;
};

export default ProjectOutlinePanel;
